import { Query } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import BackToResultsButton from "../components/BackToResultsButton";

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    resetState: (state: Query) => {
      dispatch(actions.resetState(state));
      dispatch(actions.searchPush());
    },
  };
}

export default connect(null, mapDispatchToProps)(BackToResultsButton);
